import { GenericResponse, Stopover } from '../types';
import { FilterOmissionReportType } from '../typesFinancial';
import { tosApi } from './tosApi';
import { cleanParams } from './utils';

export type OmittedStopoveresResponse = GenericResponse & {
  results: Array<Stopover> | [];
};

export type OmittedExportXmlParamsType = {
  initial_date_report: string;
  final_date_report: string;
};

export const OmissionApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    // Lista as escalas omitidas/evadidas. Filtros de data incidem sobre
    // omission_date.
    getOmittedStopoveres: build.query<
      OmittedStopoveresResponse,
      FilterOmissionReportType | void
    >({
      query: (params) => {
        return {
          url: '/maritime/stopoveres/omitted',
          method: 'GET',
          params: params ? cleanParams(params) : {},
        };
      },
      transformResponse: (response: OmittedStopoveresResponse) => {
        response.results.forEach((stopover) => {
          stopover.key = stopover.id;
        });
        return response;
      },
      providesTags: () => [{ type: 'Stopover', code: 'omitted' }],
    }),
    // Solicita a geração do XML das omissões no período informado. O endpoint
    // não devolve o arquivo: o XML é processado em segundo plano.
    exportOmittedXml: build.mutation<string, OmittedExportXmlParamsType>({
      query: (body) => {
        return {
          url: '/maritime/stopoveres/omitted/export-xml',
          method: 'PUT',
          body,
          responseHandler: (response) => response.text(),
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGetOmittedStopoveresQuery, useExportOmittedXmlMutation } =
  OmissionApi;
